import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey] as const
const locationCredentialTypes = [accountNumber] as const

export type avrtCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const avrtDocumentTypes = [
  'appointment-confirmation',
  'inspection-certificate',
  'invoice',
  'proof-of-delivery',
  'signed-bol',
  'weights-and-corrections',
  'delivery-photo',
] as const satisfies readonly DocumentType[]

export const avrt: CarrierDef<avrtCredType> = {
  name: 'Averitt Express',
  scac: 'avrt',
  credentialTypes,
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed by 5pm',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    { id: 'volume', name: 'Volume' },
  ],
  locationCredentialTypes,
  legacyCredMap: [
    ['account-number', 'ref1'],
    ['api-key', 'apiKey'],
    ...userPassMap,
  ],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'profinder',
    'documents',
    'tracking',
  ],
  documentTypes: avrtDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
